import type { ThemedAnchor } from '@trmediaab/zebra';

const anchor: ThemedAnchor = {
  common: {
    outline: 'none',
  },
  variants: {
    default: {
      color: 'link.primary',
      textDecoration: 'none',
      '&:hover, &:focus-visible': {
        color: 'link.active',
      },
    },
    matchText: {
      color: 'inherit',
      textDecoration: 'none',
      '&:hover, &:focus-visible': {
        textDecoration: 'underline',
      },
    },
  },
};

export default anchor;
